/*账单收款 */
import { $http, buildHeaders } from "./index";

//获取列表
export const collectedplan_page = (params) => {
  return $http.get("/admin/CollectedPlan/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取收款计划单条信息
export const collectedplan_detail = (id) => {
  return $http.get(
    "/admin/CollectedPlan/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取收款计划详情
export const collectedplan_search = (id) => {
  return $http.get(
    "/admin/CollectedPlan/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//收款
export const collectedplan_collect = (data) => {
  return $http.post("/admin/CollectedPlan/collect", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
